// extracted by css-extract-rspack-plugin
export default {"rivers":"WorkflowSection-module__rivers__i8OEl","bento":"WorkflowSection-module__bento__F_1mG"};